import React from "react";
import { useParams } from "react-router-dom";

import Loading from "components/Loading";
import NewWorkbookButton from "components/NewWorkbookButton";
import WorkbookListTable from "components/WorkbookListTable";

import { useWorkbooksForServerGroupQuery } from "./gql/Query.generated";

const ServerGroupWorkbookList = () => {
  const { serverGroupId } = useParams();
  const { loading, error, data, refetch } = useWorkbooksForServerGroupQuery({
    variables: { serverGroupId },
  });

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <WorkbookListTable
      workbooks={data.getWorkbooks}
      showServerColumn
      showDatabaseColumn
      onDeleted={() => {
        refetch();
      }}
      toolbar={<NewWorkbookButton />}
    />
  );
};

export default ServerGroupWorkbookList;
